const Sidebar = ({board})=>{
    const cambio = (text)=>{
        board(text)
    }
    return(
        <div className="sidebar">
            <a href='#1'onClick={() => cambio('index')}>Inicio</a>
            <a href='#1'onClick={() => cambio('users')}>Gestión de Usuarios</a>
            <a href='#1'onClick={() => cambio('sorteos')}>Gestión de Sorteos</a>
            <a href='#1'onClick={() => cambio('money')}>Finanzas</a>
            <a href='#1'onClick={() => cambio('notificaciones')}>Notificaciones</a>
            {/* <a onClick={() => cambio('promos')}>Promociones</a>
            <a onClick={() => cambio('reports')}>Reportes</a>
            <a onClick={() => cambio('soport')}>Soporte</a> */}
        </div>
    )
}
export default Sidebar